import { useContext } from "react";
import SelectController from "../../../../../../core/ui/components/SelectController";
import CuadroTurnosContext from "../../../../store/cuadro-turnos-context";
import TurnosConvencionesContext from "../../../../store/modal-convenciones-context";
import SelectsFiltrosCuadrosTurnosContext from "../../../../store/selects-filtros-cuadros-turnos-context";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

export default function SelectFiltroTurno() {
    const { setFiltros } = useContext(CuadroTurnosContext);
    const { convenciones } = useContext(TurnosConvencionesContext);
    const {
        control,
        setValue,
        formState: { errors },
    } = useForm({
        defaultValues: { filtroTurno: null },
    });

    const filtroTurnos = convenciones.reduce((prev, turno) => {
        if (!Object.prototype.hasOwnProperty.call(prev, turno.id)) {
            prev[turno.id] = {
                label: turno.sigla,
                value: turno.id,
            };
        }

        return prev;
    }, {});
    const opciones = Object.values(filtroTurnos);

    const { turnos, setTurnos } = useContext(SelectsFiltrosCuadrosTurnosContext);

    useEffect(() => {
        const turnosSeleccionados = opciones.filter((tu) => turnos.includes(tu.value));
        setValue('filtroTurno', turnosSeleccionados)
    }, [turnos]);


    const onChangeFiltroTurno = (turnos) => {
        turnos ??= [];
        const turnosFiltros = turnos.map((turno) => {
            return turno.value;
        });

        setFiltros((prev) => {
            return { ...prev, turnos: turnosFiltros };
        });
        setTurnos(turnosFiltros)
    };

    return (
        <div>
            <label className="mt-2">
                <i className="fas fa-user-clock"></i> Turno
            </label>
            <SelectController
                control={control}
                errors={errors}
                name="filtroTurno"
                onChange={onChangeFiltroTurno}
                isMulti={true}
                zIndex={200}
                options={opciones}
            />
        </div>
    );
}
